import React, { useRef, useState, useEffect } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.css';

import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

import { Autoplay, Pagination, Navigation } from 'swiper/modules';


const videoData = [
  {
    id: 1,
    videoUrl: 'https://dev.opusbuildersla.com/wp-content/uploads/2023/11/hermosa2.mp4',
    title: '5427 Mount Helena Ave',
    link: 'https://dev.opusbuildersla.com/',
  },
  {
    id: 1,
    videoUrl: 'https://dev.opusbuildersla.com/wp-content/uploads/2023/11/hermosa2.mp4',
    title: '940 Avenue 37',
    link: 'https://dev.opusbuildersla.com/',
  }
  // Add more video data here
];


  export default function VideoSlider() {
  const progressCircle = useRef(null);
  const progressContent = useRef(null);
  const onAutoplayTimeLeft = (s, time, progress) => {
    progressCircle.current.style.setProperty('--progress', 1 - progress);
    progressContent.current.textContent = `${Math.ceil(time / 1000)}s`;
  };
  
  
  const [postList, setPostList] = useState([]);
  const [error, setError] = useState(null);

  useEffect(() => {
    // Replace 'your_post_type' with the actual post type you want to retrieve
    const postType = 'project';
    const apiUrl = `https://dev.opusbuildersla.com/wp-json/wp/v2/${postType}?_embed&acf`;

    fetch(apiUrl)
      .then((response) => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then((data) => {
        setPostList(data);
      })
      .catch((error) => {
        setError(error);
      });
  }, []); // Empty dependency array to ensure the effect runs only once

  if (error) {
    return <div>Error: {error.message}</div>;
  }

  if (postList.length === 0) {
    return <div>No posts found for the specified post type.</div>;
  }
  
  return (
    <>
    <Swiper
   
        centeredSlides={true}
        autoplay={{
          delay: 5000,
          disableOnInteraction: false,
        }}
        pagination={{
          clickable: true,
        }}
        navigation={true}
        modules={[Autoplay, Pagination, Navigation]}
        onAutoplayTimeLeft={onAutoplayTimeLeft}
        className="mySwiper"
      spaceBetween={20}
      slidesPerView={1}
      
    >
      {videoData.map((video) => (
        <SwiperSlide key={video.id}>
          <div className="video-slide">
            <video controls width="100%" muted="muted" preload="metadata" loop="loop" autoplay="autoplay" webkit-playsinline="webkit-playsinline" playsinline="playsinline" data-object-fit="cover">
                    <source src={video.videoUrl} type="video/mp4" />
                    Your browser does not support the video tag.
            </video>
            <div class="video_caption">
            <h3>{video.title}</h3>
            <div class="video_link"><a href="{video.link}">Discover more</a></div>
            </div>
          </div>
        </SwiperSlide>
      ))}
      <div className="autoplay-progress" slot="container-end">
          <svg viewBox="0 0 48 48" ref={progressCircle}>
            <circle cx="24" cy="24" r="20"></circle>
          </svg>
          <span ref={progressContent}></span>
        </div>
    </Swiper>
    
    <div class="properties_list">
            {postList.map((post) => (
              <a href={post.link} class="single_project" key={post.id}>
                <div class="content">
                  <div class="project_type">{post.acf.project_type}</div>
                  <h2>{post.title.rendered}</h2>
                  <a href={post.link} target="_blank" rel="noopener noreferrer">
                View Project
              </a>
                </div>
                <div class="project_img">
                {post._embedded && post._embedded['wp:featuredmedia'] && (
                  <img
                    src={post._embedded['wp:featuredmedia'][0].media_details.sizes['full'].source_url}
                    alt={post._embedded['wp:featuredmedia'][0].alt_text}
                    style={{ maxWidth: '100%', height: 'auto' }}
                  />
                )}
                </div>
                <div dangerouslySetInnerHTML={{ __html: post.content.rendered }} />
              </a>
            ))}
      </div>
  </>
  );
}

